import { Card, CardContent, Typography, useTheme } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import type { VendaHistoricoItem } from '@azoupvendas/shared';

interface Props {
  dados: VendaHistoricoItem[];
}

function formatCurrency(value: number): string {
  if (value >= 1_000_000) return `R$${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `R$${(value / 1_000).toFixed(0)}K`;
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function VendasHistoricoChart({ dados }: Props) {
  const theme = useTheme();

  return (
    <Card>
      <CardContent>
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          Vendas — últimos 13 meses
        </Typography>
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={dados} margin={{ top: 4, right: 8, left: 8, bottom: 4 }}>
            <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} tickLine={false} axisLine={false} />
            <YAxis
              tickFormatter={formatCurrency}
              tick={{ fontSize: 11 }}
              tickLine={false}
              axisLine={false}
              width={64}
            />
            <Tooltip
              formatter={(value: number) =>
                value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
              }
              contentStyle={{
                borderRadius: 8,
                border: `1px solid ${theme.palette.divider}`,
                fontSize: 12
              }}
            />
            <Bar
              dataKey="total"
              name="Vendas"
              fill={theme.palette.primary.main}
              radius={[4, 4, 0, 0]}
              maxBarSize={40}
            />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
